import { Component, OnInit, Input, ElementRef, ViewChild, Output, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Events } from '@ionic/angular';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { EventEmitter } from '@angular/core';
import { HeaderUtilsService } from '../header-utils.service';
import { Storage } from '@ionic/storage';
import { AdminSettingsService } from 'src/app/services/admin-settings/admin-settings.service';

@Component({
  selector: 'app-header-nine',
  templateUrl: './header-nine.component.html',
  styleUrls: ['./header-nine.component.scss'],
})
export class HeaderNineComponent implements OnInit {
  @ViewChild('navMenu',{static:false}) navMenu: ElementRef;
  @Input() headerData: any;
  @Input() data: any;
  @Input() region: any;
  @Output() openRegionModalEvent = new EventEmitter();
  @Input() stickyHeader: boolean;
  @Output() getStickyHeight = new EventEmitter();

 

  loginStatus = false;
  isPriceReq: boolean;
  showPrices: boolean;
  page: number = 0;
  stickyHeight = 150;
  isIOS;
  role: any;
  userId: string = '';
  priceForRetail = false;
  currencyCode: any;
  RFQFeature = false;
  storeData: any = {
    allowComment: false,
    allowStoreInfo: false,
    appPackageName: "",
    appVersion: "",
    commentMsg: "",
    facebookUrl: "",
    instagramUrl: "",
    storeAddress: {
        address: "",
        city: "",
        state: "",
        stateCode: ""
    },
    storeInfo: "",
    storeName: "",
    storePhone: "",
    twitterUrl: "",
    welcomeMsg: "",
    youtubeUrl: "",
    whatsappNumber: "",
};
  constructor(private router: Router,
      private events: Events,
      public userService: UserService,
      private headerUtilsService: HeaderUtilsService,
      private storage: Storage,
      private adminSettingsService: AdminSettingsService,
      private utilsService: UtilsService, ) { }

      dropMenu() {
        const navMenu = this.navMenu.nativeElement.parentNode.classList;
        console.log(navMenu.toggle('dBlock'));
      }

  openRegionModal(type) {
      this.openRegionModalEvent.emit(type);
  }

  async ngOnInit() {
      if (this.data) {
          this.role = this.data.role;
          this.priceForRetail = this.data.priceForRetail;
          this.currencyCode = this.data.currencyCode;
          this.RFQFeature = this.data.loginStatus;
      }
      this.initializeSubscriptions();

      this.loginStatus = this.headerUtilsService.getLoginStatus();


  }
  async initializeSubscriptions() {
      this.events.subscribe('auth:logoutSuccess', () => {
          this.loginStatus = false;
      });

      let storeData: any;
      storeData = await this.storage.get('storeInfo');
      if(!storeData) {
          storeData = await this.adminSettingsService.getStoreInfo('return');
      }
      if (storeData) {
          this.storeData = storeData;
       
        //   if (storeData.whatsappNumber) {
        //       this.whatsappURL = 'https://wa.me/' + this.configService.environment.defaultCountryCode + storeData.whatsappNumber;
        //   }
      }
  }

  ngOnDestroy() {
      this.removeSubscriptions();
  }
  removeSubscriptions() {
      this.events.subscribe('auth:logoutSuccess');
  }
  logout() {
      this.events.publish('auth:logout');
  }
  async openLoginModal() {
      this.utilsService.openLoginModal();
  }
  openSearchPage() {
      this.headerUtilsService.openSearchPage();
  }
}
